import { Toaster as SonnerToaster } from "@workspace/ui/components/sonner";

const ToastProvider = () => (
  <SonnerToaster
    closeButton
    duration={4000}
    position="bottom-right"
    toastOptions={{ style: { borderRadius: "var(--radius)" } }}
  />
);

export { ToastProvider };
